// Angular
import { Component, Input, OnInit, ChangeDetectionStrategy,ChangeDetectorRef } from '@angular/core';
// RxJS
import { Observable, Subscription } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { GlobalService } from '../../../../../core/global.service';
import { ConstantService } from '../../../../../core/constant.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrls: ['./user-profile.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserProfileComponent implements OnInit {
	public udata;
	isLoadingParents = true; // add this at top

	@Input() avatar: boolean = true;
	@Input() greeting: boolean = true;
	@Input() badge: boolean;
	@Input() icon: boolean;
	public checkSwitchPanel;
	switchPanelHdr: any;
	public last_user;
	public switchPanelHdr1;
	public switchRolePanelHdr;
	userName: any;
	public childList: Child[]
	public accno;

	public isParents: boolean = true
	private subscriptions: Subscription[] = []
	public notificationcount: any;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */

	constructor(private store: Store<AppState>, private globalservice: GlobalService, private router: Router, public constants: ConstantService, private cd: ChangeDetectorRef,public toastr: ToastrService,) {
		this.udata = JSON.parse(localStorage.getItem('currentuser'));
		this.accno=this.udata.user_info.account_no
		this.userName = this.udata.user_info.username
		if (localStorage.getItem("checkSwitchPanel")) {
			this.switchPanelHdr1 = localStorage.getItem("checkSwitchPanel");
		}
		if (localStorage.getItem("roleType")) {
			this.switchRolePanelHdr = localStorage.getItem("roleType");
		}
		if (localStorage.getItem("last_user_type")) {
			this.switchPanelHdr = localStorage.getItem("last_user_type") == 'user' ? true : false;
			// console.log(this.switchPanelHdr,this.udata.user_info.user_type  , this.childList)
		}
	}
	switchClick1() {
		this.last_user = JSON.parse(localStorage.getItem("last_user"));
		if (this.last_user) {
			this.router.navigate([
				"/admin/impersonate/" + this.last_user + "/admin",
			]);
		} else {
			this.router.navigate(["/admin/impersonate/admin/admin"]);
		}
	}
	refresh() {
		this.cd.detectChanges();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (localStorage.getItem('checkSwitchPanel')) {
			this.checkSwitchPanel = localStorage.getItem('checkSwitchPanel');
		}
		var obj = this.globalservice;
		var token = this.udata['access_token'];
		var info = this;
		let intervalId = window.setInterval(function () {
			obj.checkuser(token).then((result) => {
				obj.updateUserCredit(result.credit);
				info.refresh();
			}, (err) => {
				window.clearInterval(intervalId);
				if (err.error.message == 'Token has expired') {
					obj.terminateUser();
					return;
				}
				if (err.error.status == 'login_attempt_exceed') {
					obj.terminateUser();
					return;
				}
			});
		}, 5000);
		this.subscriptions.push(this.globalservice.NotificationCount$.subscribe(
			(res) => {
			  if (res) {
				this.notificationcount = res

			  }
			}
		  ))
		this.getChildList();
		if (
			!this.switchPanelHdr &&
			this.udata.user_info.user_type === 'user'
			) {
				if (!localStorage.getItem("last_user_type")) {
					// console.log(this.udata.user_info)
					if (!this.udata.user_info.parent_id) {
						let val = localStorage.getItem("last_user_type")
						this.switchPanelHdr = JSON.parse(val) == 'admin' ? false : true
					}
				} else {
					let val = localStorage.getItem("last_user_type")
						this.switchPanelHdr = JSON.parse(val) == 'admin' ? false : true
				}
			// 	console.log(this.switchPanelHdr)
		  }
	}
	
	getChildList() {
		this.globalservice.getImpersonateCustomers(this.udata['access_token']).then((result) => {
    this.childList = result;

    if (this.childList.length > 0 && this.accno) {
      const matchedParent = this.childList.find(
        (item: any) => item.type === 'parent' && item.account_no === this.accno
      );

      this.isParents = !!matchedParent;

      if (matchedParent) {
        console.log('✅ Matching parent account found:', matchedParent.account_no);
      }

	  this.cd.detectChanges();
    }

  }, (err) => {
    console.error('Error fetching impersonate customers:', err);
  });
	  }
	/**
	 * Log out
	 */
	logout() {
		// this.store.dispatch(new Logout());
		this.globalservice.logout(this.udata['access_token']).then((result) => {
				localStorage.clear();
				this.globalservice.isLogin = false;
				// if(this.globalservice.userType == 'user'){
				this.router.navigate(['/login']);
				// }else{
				// 	this.router.navigate(['/admin']);
				// }
		   }, (err) => {

			if (err.error.status === 'Token is Expired') {
				this.globalservice.terminateUser();
				return;
			}

			if (err.error.status == 'login_attempt_exceed') {
				this.globalservice.terminateUser();
				return;
			}
			this.globalservice.terminateUser();
		});
	}
	navigate() {
		if (this.udata['user_info']['user_type'] == 'user') {
			this.router.navigate(['/inbound/order-history'])
		} else {
			this.router.navigate(['/admin/did/order-history'])
		}
	}

	switchClick(username: string) {
		localStorage.setItem('checkSwitchPanel', '1');
		localStorage.setItem('roleType', '1');
		this.router.navigate([`/admin/impersonate/${username}/user`]);

	  }

	  switchtoParents() {
		const parentUser = this.childList.find((item: Child) => item.type === 'parent');

		console.log('Parent user:', parentUser);

		if (parentUser) {
		  localStorage.setItem('checkSwitchPanel', '1');
		  localStorage.setItem('roleType', '1');
		  this.router.navigate([`/admin/impersonate/${parentUser.username}/user`]);
		} else {
		  localStorage.setItem('roleType',null);
		}
	  }
}

interface Child {
	id: number;
	name: string;
	email: string;
	account_no: string;
	username: string;
	type: string;
  }